import React, { useCallback } from 'react';

import { staticDispatch, useSelector } from 'reduxState/store';
import {
  showDesktopQRConnectModal,
  showWalletModal,
} from 'reduxState/wallet/walletDetailsReducer';

import UnlockCore from './UnlockCore';

function UnlockModal() {
  const isMobile = useSelector(state => state.screen.isMobile);
  const walletDetail = useSelector(state => state.walletDetail);
  const skipDesktopQrConnectModal = useSelector(
    state => state.exchange.userGuide.skipQrConnectModal
  );
  const {
    unlockModalDelegationDisabled,
    unlockModalKeepWalletUntilSuccess,
    unlockModalOpen,
    unlockModalAfterGoTo,
  } = walletDetail;

  const unlockCallback = useCallback(() => {
    staticDispatch(showWalletModal({ show: false }));
    if (!skipDesktopQrConnectModal && !isMobile) {
      staticDispatch(showDesktopQRConnectModal('standard'));
    }
  }, [skipDesktopQrConnectModal, isMobile]);

  if (!unlockModalOpen) {
    return null;
  }
  return (
    <UnlockCore
      afterUnlockCallback={unlockCallback}
      afterUnlockGoTo={unlockModalAfterGoTo}
      delegationDisabled={unlockModalDelegationDisabled}
      keepWalletUntilSuccess={unlockModalKeepWalletUntilSuccess}
      layout="modal"
    />
  );
}

export default UnlockModal;
